import { Injectable, Pipe, PipeTransform } from "@angular/core";
import { GeocodeService } from "@app/services/geocode.service";

@Pipe({ name: 'location' })
@Injectable()
export class VLocationPipe implements PipeTransform {
    constructor(private readonly geocodeService: GeocodeService) { }

    transform(input: number): Promise<string> {

        if (!input || isNaN(Number(input))) {
            return Promise.resolve(null);
        }

        return new Promise((res, rej) => {
            // Wrapping angular iPromise in an ES6 Promise so that the async pipe can be used
            this.geocodeService.getLocationInformationFromPlotId(Number(input)).then(location => {
                if (!location) {
                    return rej("No location found for plot" + input)
                }

                return res(location.LocationDescription);
            })
        })
    }
}
